module.exports = __webpack_public_path__ + "static/media/Colette Single 2-Drawer Bed Base 90x200_Grey.1410e3e2.png";